export default __webpack_public_path__ + "static/media/auditory.aa4d8023.svg";